import React from 'react';
import { Link } from 'react-router-dom';
import ContentCard from '../Layouts/ContentCard';
import LoadingSpiner from '../Components/Loader/LoadingSpiner';
import { FaExclamationCircle, FaTrashRestore } from 'react-icons/fa';
import { useListDeletedProjectsQuery, useUndoDeleteProjectMutation } from '../api/project';
import { useListDeletedImagesQuery } from '../api/image';

interface Deleted {
    id: string;
    name: string;
    project_id?: string;
    deleted_at?: string;
}

function DeletedProjects() {
    const { data, isLoading, isError } = useListDeletedProjectsQuery({});
    const [restore, { isLoading: restoreLoading }] = useUndoDeleteProjectMutation();

    if (isLoading) return <div className='text-center mt-4'><LoadingSpiner /></div>;
    if (isError) return <p className='mt-4'><FaExclamationCircle className='inline mr-2' /> Error loading deleted projects</p>;

    const items: Deleted[] = (data ?? []).filter(Boolean);

    return (
        <div className='mt-4'>
            <h3 className='font-semibold mb-2'>Projects</h3>
            {items.length === 0 ? (
                <p className='text-sm opacity-70'>Trash is empty.</p>
            ) : (
                <table className='table w-full'>
                    <tbody>
                        {items.map((p) => (
                            <tr key={p.id}>
                                <td>{p.name}</td>
                                <td className='text-right'>
                                    <button
                                        className='btn btn-ghost btn-xs'
                                        disabled={restoreLoading}
                                        onClick={() => restore(p.id)}
                                    >
                                        <FaTrashRestore className='inline mr-1' /> Restore
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

function DeletedImages() {
    const { data, isLoading, isError } = useListDeletedImagesQuery({});

    if (isLoading) return <div className='text-center mt-4'><LoadingSpiner /></div>;
    if (isError) return <p className='mt-4'><FaExclamationCircle className='inline mr-2' /> Error loading deleted images</p>;

    const items: Deleted[] = (data ?? []).filter(Boolean);

    return (
        <div className='mt-4'>
            <h3 className='font-semibold mb-2'>Images</h3>
            {items.length === 0 ? (
                <p className='text-sm opacity-70'>No deleted images.</p>
            ) : (
                <table className='table w-full'>
                    <tbody>
                        {items.map((img) => (
                            <tr key={img.id}>
                                <td>{img.name}</td>
                                {/* ponytail: restore disabled — server undo-delete route broken (app-apis#92) */}
                                <td className='text-right'>
                                    <button className='btn btn-ghost btn-xs' disabled title='Restore unavailable (app-apis#92)'>
                                        <FaTrashRestore className='inline mr-1' /> Restore
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default function TrashPage() {
    return (
        <div className='container mx-auto'>
            <ContentCard title="Trash">
                <p>All items in the Trash Bin will be permanently deleted 15 days from their removal date. Ensure essential data is restored promptly.</p>
                <DeletedProjects />
                <DeletedImages />
            </ContentCard>
        </div>
    );
}
